import api from "./http";

export const getNotifications = ({ page = 1, limit = 20, unreadOnly = false } = {}) =>
  api.get("/notifications", {
    params: {
      page,
      limit,
      unreadOnly,
    },
  });

export const getUnreadCount = () => api.get("/notifications/count");

export const markRead = (ids = []) =>
  api.put("/notifications/read", {
    ids,
  });

export const deleteNotification = (id) => api.delete(`/notifications/${id}`);
